<template>
  <Button :title="title|| $t('loginButton')" @click.native="login" />
</template>

<script lang="ts">
import cms from '@/cms'
import { TranslationHandler } from '../../mixins/translation-handler'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Action } from 'vuex-class'

@Component({
  components: {
  }
})
export default class LoginButton extends Mixins(TranslationHandler) {
  @Action('AUTH_LOGIN') authLogin!: () => void
  @Prop() title!: string|null

  login () {
    cms.tracking.trackCustomer('login_start', { login_method: 'spotify' })
    this.authLogin()
  }
}
</script>
